import { render, staticRenderFns } from "./ManageSystemContentItem.vue?vue&type=template&id=b76c67ec&scoped=true&"
import script from "./ManageSystemContentItem.vue?vue&type=script&lang=js&"
export * from "./ManageSystemContentItem.vue?vue&type=script&lang=js&"
import style0 from "./ManageSystemContentItem.vue?vue&type=style&index=0&id=b76c67ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76c67ec",
  null
  
)

export default component.exports